import { StepEditorProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { ErrorMessage, IconButton, Stack, Title } from "@introist/react-foundation/v2";
import { Block } from "../../../../components/atoms";
import { prefixForm } from "../../../../utils/FormUtils";
import { SlackSenderSelectV2 } from "../../../workflows/routes/WorkflowEditor/StepEditor/SlackStepEditorV2/blocks/SenderAndRecipients/components/SlackSenderSelectV2";
import { AttachmentsBlock } from "../../..//workflows/blocks/Attachments";
import { SlackUserSelect } from "./SlackUserSelect";
import { LangMessageEditor } from "../../../../components/editors/LangMessageEditor";
import { TagSelector } from "../../../system/tags/TagSelector";
import { Tags } from "../../../system/tags/useTags";

export const SlackDirectMessageEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  const messageError = prefixedForm.error("message");

  const senderId = prefixedForm.get("senderId");
  const dynamicSender = prefixedForm.get("sender");
  const hasSender = senderId || dynamicSender;

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Sender & Recipients" defaultOpen>
          <Stack vertical alignItems="stretch" gap="large">
            <StepEditorAccordion.Row label="From">
              <Stack>
                {(!hasSender || senderId) && (
                  <SlackSenderSelectV2
                    placeholder="Sender"
                    senderId={prefixedForm.get("senderId")}
                    onSelectSender={senderId => {
                      prefixedForm.setMany({
                        senderId,
                        sender: null
                      });
                    }}
                    error={prefixedForm.isError("senderId")}
                  />
                )}
                {!hasSender && <Title>or</Title>}
                {(!hasSender || dynamicSender) && (
                  <TagSelector
                    wrap
                    variant="blended"
                    size="small"
                    onSelect={tag =>
                      prefixedForm.setMany({
                        sender: Tags.wrap(tag.tag),
                        senderId: null
                      })
                    }
                    value={
                      prefixedForm.get("sender") ? Tags.unwrap(prefixedForm.get("sender")) : null
                    }
                    title="Dynamic"
                    ctx={{
                      fieldTypes: ["email"],
                      workflowId
                    }}
                  />
                )}
                {hasSender && (
                  <IconButton
                    style={{ marginLeft: "auto" }}
                    icon="crossSmall"
                    onClick={() => prefixedForm.setMany({ senderId: null, sender: null })}
                  />
                )}
              </Stack>
            </StepEditorAccordion.Row>
            <StepEditorAccordion.MultiOptionRow label="Users">
              <SlackUserSelect
                senderId={prefixedForm.get("senderId")}
                error={prefixedForm.isError("users")}
                value={prefixedForm.get("users") ?? []}
                onChange={prefixedForm.set("users")}
                workflowId={workflowId}
              />
            </StepEditorAccordion.MultiOptionRow>
          </Stack>
        </StepEditorAccordion>
      </Block>
      <Block compact blended>
        <StepEditorAccordion title="Message" defaultOpen>
          <Stack vertical gap="xLarge">
            <LangMessageEditor
              value={prefixedForm.get("langs")}
              onChange={prefixedForm.set("langs")}
              error={!!messageError}
              tags={{
                workflowId
              }}
            />
            {messageError && <ErrorMessage>{messageError}</ErrorMessage>}
          </Stack>
        </StepEditorAccordion>
      </Block>
      <AttachmentsBlock form={form} />
    </>
  );
};
